import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components'
// eslint-disable-next-line max-len
import { useRelationshipsReportContext } from '~bank-reports/routes/RelationshipsReport/context/RelationshipsReportContext'

import { columns } from './columns'

export const RelationshipsReportTable = () => {
  const {
    data: {
      form: { page, size },
      total,
      items
    },
    routeApi,
    isFetching
  } = useRelationshipsReportContext()
  const navigate = routeApi.useNavigate()

  return (
    <Table
      dataQa={TableDataQa.BP_REPORTS_RELATIONSHIPS_REPORT}
      dataSource={items.map((item) => ({ item }))}
      loading={isFetching}
      columns={columns}
      pagination={{
        page,
        size,
        onChange: (page, size) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
        },
        total
      }}
    />
  )
}
